//Generated File 
export const alone = `alone`;
export const normal = `normal`;
export const spanned = `spanned`;
export const spanned2 = `spanned2`;
export const startnewline = `startnewline`;
